import React from "react";
import Typography from "@material-ui/core/Typography";
import QuestionVariantsList from "../QuestionVariantsList";
import useQuestionDetails from "./useQuestionDetails";
import QuestionScale from "../QuestionScale";
import {withStyles} from "@material-ui/core/styles";

const styles = theme => ({
  info: {
    width: "100%",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-end",
    justifyContent: "space-between"
  }
});

export const QuestionDetails = ({question, classes}) => {
  const {
    createVariant,
    deleteVariant,
    updateQuestionScale,
    updatedScale,
    setUpdatedScale,
    isCreatingVariant,
    isDeletingVariant,
    createdVariant,
    setCreatedVariant,
    dataSources,
    getVariantList
  } = useQuestionDetails();

  return <div>
    <div className={classes.info}>
      <Typography variant="body1" component="span">
        Шаблон: <strong>{question.typeName}</strong>
      </Typography>
      <Typography variant="body1" component="span">
        {question.isRequired ? 'Обязательный' : 'Необязательный'}
      </Typography>
    </div>
    <Typography variant="caption" color="textSecondary" display="block">
      {question.typeDescription}
    </Typography>
    {(question.typeId === 4 || question.typeId === 5 || question.typeId === 6) &&
      <QuestionVariantsList questionId={question.id}
                            variants={dataSources.variants}
                            getVariantList={getVariantList}
                            createVariant={createVariant}
                            deleteVariant={deleteVariant}
                            createdVariant={createdVariant}
                            setCreatedVariant={setCreatedVariant}
      />
    }

    {question.typeId === 7 &&
      <QuestionScale updateQuestionScale={(formData) => updateQuestionScale(question.id, formData)}
                     updatedScale={updatedScale}
                     setUpdatedScale={setUpdatedScale}
                     min={question.minValue}
                     max={question.maxValue}
                      />
    }
  </div>
};

export default withStyles(styles)(QuestionDetails);
